import Base from 'app/collections/base';
import FulfillmentBOLLineItem from 'app/models/fulfillment_bol_line_item';

export default Base.extend({
  model: FulfillmentBOLLineItem,
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_bol_line_items.js